import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectOngoingPurchaseInfoPremium } from "../../selectors/selectOngoingPurchaseInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonConfirmation } from "../generic/common/ButtonConfirmation";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionSpendGoldConfirmation } from "./actionSpendGoldConfirmation";
var DialogSpendGoldConfirmationDOM = function (_a) {
    var onHandleConfirmation = _a.onHandleConfirmation, premiumInfo = _a.premiumInfo;
    var isGoldAmountAvailable = premiumInfo != undefined && premiumInfo.goldAmount != undefined;
    var goldAmount = isGoldAmountAvailable ? premiumInfo.goldAmount.low : 0;
    var locaReplacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(goldAmount)]]);
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.spendGoldConfDialog_title, onClose: function () { return onHandleConfirmation(false); }, className: IdStyles.ModalBackgroundResources },
        React.createElement("div", { className: "spend-gold-dialog-description" },
            React.createElement("div", { className: IdStyles.TextBoldPrimary },
                React.createElement(TextLoca, { id: IdLoca.spendGoldConfDialog_desc, replacements: locaReplacements })),
            React.createElement(ButtonConfirmation, { onClickCancel: function () { return onHandleConfirmation(false); }, onClickConfirm: function () { return onHandleConfirmation(true); } }))));
};
var mapState = function (state) { return ({
    premiumInfo: selectOngoingPurchaseInfoPremium(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onHandleConfirmation: function (status) {
        dispatch(actionSpendGoldConfirmation(status));
        dispatch(actionModalClose(IdModal.SpendGoldConfirmation));
    },
}); };
export var DialogSpendGoldConfirmation = connect(mapState, mapDispatch)(DialogSpendGoldConfirmationDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/spend-gold-confirmation/DialogSpendGoldConfirmation.tsx
// module id = 2926
// module chunks = 3